import { Container } from "@chakra-ui/react";
import FeatureCard from "../../components/features/FeatureCard";
import styles from "./features.module.scss";
import { useScrollAnimation } from "../../hooks/useScrollAnimation";

export type FeatureData = {
  title: string;
  description: string;
  image: string;
};

const featuresData: FeatureData[] = [
  {
    title: "Machine learning",
    description:
      "State-of-the-art machine learning algorithms allow to gain deep insights from big data",
    image: "/media/icons/brain_black.png",
  },
  {
    title: "Process Understanding",
    description:
      "Profound experience in regulatory and advanced process controls allow to design optimal solutions",
    image: "/media/icons/process_black.png",
  },
  {
    title: "Dynamic Visualization",
    description:
      "Making insights that matter available in real-time allow to make decisions that make a difference",
    image: "/media/icons/visual_black.png",
  },
  {
    title: "Gamified Training",
    description:
      "Transform tedious documentation into engaging experiences that empower employees to grow with their tasks",
    image: "/media/icons/gamification_black.png",
  },
];

const Features = () => {
  const { elementRef: titleRef, isVisible: titleVisible } = useScrollAnimation({ threshold: 0.2 });
  const { elementRef: cardsRef, isVisible: cardsVisible } = useScrollAnimation({ threshold: 0.15 });

  return (
    <div className={`sectionContainer ${styles.features}`} id="features">
      <Container>
        <div
          ref={titleRef}
          className={`${styles.featuresTitle} fade-in ${titleVisible ? 'visible' : ''}`}
        >
          <h2 className="sectionSubtitle">
            Artificial Intelligence and dynamic visualization combined with gamified training
            to educate and empower employees
          </h2>
          <p className={styles.description}>
            BioLean combines machine learning, process understanding, dynamic
            visualization, and engaging training experiences to provide operators
            with real-time insights and continuous skill development for critical
            operational excellence
          </p>
        </div>
        <div
          ref={cardsRef}
          className={`${styles.cardsContainer} stagger-children ${cardsVisible ? 'visible' : ''}`}
        >
          {featuresData.map((feature, index) => (
            <FeatureCard data={feature} key={index} />
          ))}
        </div>
      </Container>
    </div>
  );
};

export default Features;
